import { HotelDescriptionController } from "./hotel-description.controller";
import { Bindings } from "booking_app/types";

export class HotelDescriptionComponent {
  bindings: any = {
    hotelDetail: Bindings.ONE_WAY,
  };
  controller: any = HotelDescriptionController;
  template: string = `
    <div class="hotel-description">
      <div class="headline-container">
        <h3 class="title color-headline" translate="txt.hotel_overview"></h3>
        <div class="chevron-container">
          <a class="fa" ng-click="$ctrl.toggleDescription()"
            ng-class="$ctrl.showFullDescription() ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-label="{{ $ctrl.showFullDescription() ? 'Collapse hotel overview' : 'Expand hotel overview' }}"
            role="button"
            href="#">
          </a>
        </div>
      </div>
      <div ng-if="$ctrl.isDescriptionLoading()" class="hotel-description-loading"
        ng-repeat="x in [].constructor(4) track by $index">
        <div class="first-loading-description"> </div>
        <div class="second-loading-description"> </div>
        <div class="second-loading-description" ng-if= "$index % 2 == 1"> </div>
        <div class="third-loading-description"> </div>
      </div>
      <div ng-if="!$ctrl.isDescriptionLoading()" class="hotelDescription clear"
        ng-class="{ 'limit-description': !$ctrl.showFullDescription() }">
        <div ng-bind-html="$ctrl.hotelDetail.description"></div>

        <!-- Mobile amenities list (visible only on sm and xs screens) -->
        <div class="visible-sm-block visible-xs-block" ng-if="$ctrl.shouldShowAmenities()">
          <div class="amenities-list-mobile-section" ng-if="$ctrl.hasGuestLove()">
            <h3 class="is-visually-hidden">Attractive attributes of the hotel</h3>
            <b translate="txt.guest_love_title"></b>
            <div ng-repeat="list in $ctrl.guestLoveList()">• {{list}}</div>
          </div>
          <div class="amenities-list-mobile-section" ng-if="$ctrl.hasAmenities()">
            <h3 class="is-visually-hidden">Hotel Facilities</h3>
            <b translate="txt.facilities"></b>
            <div ng-repeat="(amenity, isPresent) in $ctrl.hotelDetail.amenities" ng-if="isPresent">
              • <span translate="{{amenity}}"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

angular.module("BookingApp").component("hotelDescription", new HotelDescriptionComponent());
